import React from 'react';

import Heading from 'common/components/Heading';
import Text from 'common/components/Text';

import styles from './index.module.css';

const NoWithdrawalsYet = () => (
  <div className={styles.root}>
    <div className={styles.content}>
      <div className={styles.message}>
        <Heading size="2" level="2" color="blue">
          No withdrawals yet
        </Heading>
        <Text>
          Once you submit your first withdrawal request it will display here
        </Text>
      </div>
    </div>
  </div>
);

export default NoWithdrawalsYet;
